module.exports = __webpack_public_path__ + "static/media/wujiakecheng.8102f953.png";